/* tempexp_18086-start */
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { FlexibleQuotaPromoModalProps } from 'reactApp/ui/FlexibleQuotaPromoModal/FlexibleQuotaPromoModal';

export const renderFlexibleQuotaPromoModal = ({ onClose, ...data }: FlexibleQuotaPromoModalProps) =>
    openPopupHelper({ popupName: popupNames.FLEXIBLE_QUOTA_PROMO_MODAL, data, onClose });

export const closeFlexibleQuotaPromoModal = () => closePopupHelper(popupNames.FLEXIBLE_QUOTA_PROMO_MODAL);

/* tempexp_18086-end */
